import { css, Theme } from "@emotion/react";

export const listColor = (theme: Theme) =>
  css({
    color: theme.palette.mode === "light" ? theme.palette.text.primary : "inherit",
  });
